const BARE_CURRENCY_AMOUNT = /^\$(?=\s*\d)[\d\s]+(?:(?:,|\{,\})[\d\s]+)*(?:\.\d+)?\s*$/

/**
 * Quill formula values contain raw TeX rather than math-mode delimiters.
 * Canonicalize a bare leading dollar on a plain amount so KaTeX treats it as
 * a literal currency symbol. Paired delimiters and real expressions are left
 * unchanged.
 */
export const normalizeCurrencyFormula = (tex: string): string => {
  const trimmed = tex.trim()

  return BARE_CURRENCY_AMOUNT.test(trimmed) ? `\\${trimmed}` : tex
}
